/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `PENDING` - Pending
 * * `RESPONDED` - Responded
 * * `CANCELED` - Canceled
 * * `CONFIRMED` - Confirmed
 */
export enum BookingRequestReadStatusEnum {
    PENDING = 'PENDING',
    RESPONDED = 'RESPONDED',
    CANCELED = 'CANCELED',
    CONFIRMED = 'CONFIRMED',
}
